export const paginationStandard = { totalPages: 10 };
